// extracted by mini-css-extract-plugin
module.exports = {"home-battery-G":"G_home-battery-G__m_66R"};